import { useEffect } from "react";
import "./App.css";
import "./revamp.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import MainScreen from "./screens/Main-screen";
import { goToCareersSite } from "./utils/careersSiteUrl";

function RedirectToCareers() {
  useEffect(() => {
    goToCareersSite();
  }, []);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainScreen />} />
            <Route path="/startappling" element={<RedirectToCareers />} />
            <Route path="/vacancies" element={<RedirectToCareers />} />
            <Route path="/apply-directly" element={<RedirectToCareers />} />
            <Route path="/about-us" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
